var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter-box",
    class: ("ch_" + (_vm.chapter.id) + " " + (_vm.badge && 'chapter-box--badge'))
  }, [_c('svg', {
    directives: [{
      name: "resize",
      rawName: "v-resize.border",
      value: (_vm.handleResize),
      expression: "handleResize",
      modifiers: {
        "border": true
      }
    }],
    staticClass: "cm_bg",
    attrs: {
      "width": "15",
      "height": "13",
      "viewBox": "0 0 15 13"
    }
  }, [_c('title', [_vm._v(_vm._s(_vm.chapter.name))]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "7.5",
      "width": "15",
      "y": "7.25"
    }
  }, [_c('tspan', {
    staticClass: "text",
    style: ({
      fontSize: _vm.fontSize + 'px'
    })
  }, [_vm._v(_vm._s(_vm.chapter.abbreviation))])]), _vm._v(" "), _c('polygon', {
    staticClass: "triangle cm_fill",
    attrs: {
      "points": "2,12 2,16 6,12"
    }
  })]), _vm._v(" "), (_vm.badge) ? _c('svg', {
    staticClass: "team-badge",
    attrs: {
      "width": _vm.badgeWidth,
      "height": "13",
      "viewBox": '0 0 ' + _vm.badgeWidth + ' 13'
    }
  }, [_c('text', {
    attrs: {
      "x": _vm.badgeWidth / 2,
      "width": _vm.badgeWidth,
      "y": "7.25"
    }
  }, [_c('tspan', {
    staticClass: "text",
    style: ({
      fontSize: _vm.fontSize + 'px'
    })
  }, [_vm._v(_vm._s(_vm.badge))])]), _vm._v(" "), _c('text', {
    staticClass: "badge-sizing-rect"
  }, [_c('tspan', {
    directives: [{
      name: "resize",
      rawName: "v-resize",
      value: (_vm.handleBadgeResize),
      expression: "handleBadgeResize"
    }],
    staticClass: "text",
    style: ({
      fontSize: _vm.range[0] + 'px'
    })
  }, [_vm._v(_vm._s(_vm.badge))])])]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-227bdc78","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/company/chapter-box.vue
// module id = null
// module chunks = 